export const appActions = {
  SET_ERROR: 'app/setError',
  SET_LOADING: 'app/setLoading'
};